import { useEffect, useState } from "react";
import IAsset from "../../../models/IAsset";
import { compareSmartObjectsVersions } from "../../../lib/SmartObject";
import { fetchSmartObjectJson } from "../../../lib/SmartObject/upload";

interface SmartObjectDetailsProps {
  sourceAsset: IAsset;
  newAsset: IAsset;
}

export default function SmartObjectDetails({ sourceAsset, newAsset }: SmartObjectDetailsProps) {
  if (!sourceAsset || !newAsset || !sourceAsset.smartObject || !newAsset.smartObject) return null;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [report, setReport] = useState<string[]>([]);

  useEffect(() => {
    setLoading(true);

    const init = async () => {
      try {
        const [sourceSmartObject, newSmartObject] = await Promise.all([
          fetchSmartObjectJson(sourceAsset),
          fetchSmartObjectJson(newAsset),
        ]);

        const comparison = compareSmartObjectsVersions(sourceSmartObject, newSmartObject, "smo");

        console.log("comparison", comparison);
        setReport(comparison.report);
      } catch (error) {
        console.error(error);
        setError(error as string);
      } finally {
        setLoading(false);
      }
    };

    init();
  }, [sourceAsset, newAsset]);

  if (loading) return <div>Loading Report...</div>;
  if (error) return <div>Error: {error}</div>;
  if (report.length === 0) return <div>Report not available, try again later</div>;

  return (
    <div>
      <h4>Smart Objects Report</h4>
      <ul>
        {report.map((report, index) => (
          <li key={index}>{report}</li>
        ))}
      </ul>
    </div>
  );
}
